import React from 'react'
import { useTranslation } from 'next-i18next'
import { Logo } from 'modules/ui/atoms/Logo'
import { ActionButton } from 'modules/ui/atoms/ActionButton'
import { usePaymentMethodSelection } from '../hooks/use-payment-method-selection'
import { translate } from '../../../../../utils/functions/translate'

interface PaymentMethodActionButtonProps {
  fallbackText?: string
  dataIdPrefix?: string
}

export const PaymentMethodActionButton = ({
  fallbackText = 'Continue',
  dataIdPrefix = 'payment-method-continue-button',
}: PaymentMethodActionButtonProps) => {
  const { t } = useTranslation()

  const { selectedPaymentMethod, selectedPaymentMethodConfig, isLoading } =
    usePaymentMethodSelection()

  // Show loading state when payment methods are still loading
  if (isLoading) {
    return (
      <ActionButton disabled>{t('PaymentMethodsStep.footer.continue', fallbackText)}</ActionButton>
    )
  }

  // Get the dynamic action button component from the config
  const SelectedPaymentMethodActionButton = selectedPaymentMethodConfig?.actionButton

  // Default footer labels for different payment methods
  const PaymentMethodFooterLabels: { [key: string]: string } = {
    card: translate('PaymentMethodsStep.footer.continue', 'Continue'),
    bank_transfer: translate('PaymentMethodsStep.footer.continue', 'Continue'),
  }

  return SelectedPaymentMethodActionButton ? (
    <SelectedPaymentMethodActionButton
      dataId={`${dataIdPrefix}-${selectedPaymentMethod.toLowerCase()}`}
    >
      {!selectedPaymentMethodConfig.actionButtonText && selectedPaymentMethodConfig.labelKey
        ? PaymentMethodFooterLabels[selectedPaymentMethodConfig.labelKey]
        : selectedPaymentMethodConfig.actionButtonText}
      {selectedPaymentMethodConfig?.actionButtonLogo && (
        <Logo
          name={selectedPaymentMethodConfig?.actionButtonLogo}
          altText={selectedPaymentMethodConfig?.actionButtonLogoAltText}
        />
      )}
    </SelectedPaymentMethodActionButton>
  ) : null
}
